/* eslint-disable no-unused-vars */
/**
 * @file Exemplo
 * jsdoc Board.js ControlLevel.js  Construtor.js ControlGame.js -d ../../documention
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */

import React from "react";


// Logos
import logoifsc from "./../../Assets/ifsclogo1.png";
import logocdcc from "./../../Assets/logocdcc1.png";
import logocnpq from "./../../Assets/logocnpg1.png";
import logofapesp from "./../../Assets/logofapesp1.png";
import logocapes from "./../../Assets/logocapes1.png";
import logocifar from "./../../Assets/cibfar1.png";



//Componentes de roteamento
import { Link } from "react-router-dom";

/**
 * @param {Null} Null Null
 * @description Classe geradora da função app
 * @constructor
 */

export default function View_credito(props) {

  function back(val) {
     if(val)
    return(
      <div className="flex-fill p-2 p-sm-3 d-flex align-items-start w-100 text-start">
          <div className="w-100 ">
            <Link to="/" className="icon d-flex flex-row">
            <i className="icon text-white1 fas fa-2x fa-arrow-left icon-button"></i>
              <span className="fs-4  flex d-none d-sm-block align-middle text-white1 ms-2 mt-2">
                VOLTAR
              </span>
            </Link>

          </div>
        </div>
    );
    
  }
  // ROTEAMENTO - colocar controle de estados da aplicação
  return (

      <div className="col d-flex flex-column align-items-center text-center h-100 w-100">

        {back(props.back)}

        <div className="flex-fill overflow-auto p-2 p-sm-3 bg-color1  text-center h-100 w-100 text-left">
          <div>
            <div className="row fw-light">
              <div className="col-md text-center text-sm-start text-white1">
                <div className="p-2 p-sm-3">
                  <h5 className="fw-lighter text-color4">COORDENAÇÃO E SUPERVISÃO GERAL</h5>
                  <p className="mb-1">Profa. Dra. Leila M. Beltramini</p>
                  <p className="mb-1">Profa. Dra. Nelma R. Segnini Bossolan</p>
                </div>
                <div className="p-2 p-sm-3">
                  <h5 className="fw-lighter text-color4">EDUCADORA</h5>
                  <p className="mb-1">Ma. Gislaine Costa dos Santos</p>
                </div>
                <div className="p-2 p-sm-3">
                  <h5 className="fw-lighter text-color4">CONSULTOR DE TECNOLOGIA DA INFORMAÇÃO</h5>
                  <p className="mb-1">Me. Claudinei Caetano de Souza</p>
                  <p className="mb-1">Me. Isaque Elcio De Souza</p> 
                  <p className="mb-1">Dra. Simone Ferreira Souza</p>
                </div>
              </div>
              <div className="col-md text-center text-sm-start text-white1">
                <div className="p-2 p-sm-3">
                  <h5 className="fw-lighter text-color4">DESENVOLVIMENTO DO SOFTWARE</h5>
                  <p className="mb-1">Luísa Gabriela Tupan Anastácio (versão 1.0)</p>
                  <p className="mb-1">Claudinei Caetano de Souza (versão 1.0)</p>
                  <p className="mb-1">William Luis Alves Ferreira (versão 2.0)</p>

                </div>
                <div className="p-2 p-sm-3">
                  <h5 className="fw-lighter text-color4">CONTEÚDO</h5>
                  <p className="mb-1">Ma. Marília Faustino da Silva</p>
                  <p className="mb-1">Ma. Gislaine Gomes da Costa</p>
                  <p className="mb-1">Rudison Beltramini Trevilato</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex-fill w-100 px-sm-5 bg-color1  p-3 text-center d-flex logoDivulgacao justify-content-between">
          
            <a href="https://www2.ifsc.usp.br/portal-ifsc/" target="_blink">
              <div className="logoPatrocinador">
                <img src={logoifsc} alt="Logo" />
              </div>
            </a>




          
          
            <a href="https://cdcc.usp.br/" target="_blink">
              <div className="logoPatrocinador" >
                <img src={logocdcc} alt="Logo" style={{ width: '55%' }} />
              </div>
            </a>

          
            <a href="http://www.cnpq.br/" target="_blink">
              <div className="logoPatrocinador">
                <img src={logocnpq} alt="Logo" />
              </div>
            </a>

          
            <a href="http://www.fapesp.br/" target="_blink">
              <div className="logoPatrocinador">
                <img src={logofapesp} alt="Logo" />
              </div>
            </a>
          
            <a href="https://www.capes.gov.br/" target="_blink">
              <div className="logoPatrocinador">
                <img src={logocapes} alt="Logo" />
              </div>
            </a>

            <a href="https://www.capes.gov.br/" target="_blink">
              <div className="logoPatrocinador">
                <img src={logocifar} alt="Logo" />
              </div>
            </a>

          

        </div>

      </div>
  );
}
